// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropMedia } from '../models/ApiDropMedia';
import { ApiDropType } from '../models/ApiDropType';
import { HttpFile } from '../http/http';

export class ApiLightDrop {
    'id': string;
    'wave_id': string;
    'wave_name': string;
    'author': string;
    'created_at': number;
    /**
    * Sequence number of the drop in Seize
    */
    'serial_no': number;
    'drop_type': ApiDropType;
    'title': string | null;
    'part_1_text': string | null;
    'part_1_medias': Array<ApiDropMedia>;
    'has_quote': boolean;
    'is_reply_drop': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "wave_id",
            "baseName": "wave_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "wave_name",
            "baseName": "wave_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "author",
            "baseName": "author",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "serial_no",
            "baseName": "serial_no",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "drop_type",
            "baseName": "drop_type",
            "type": "ApiDropType",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "part_1_text",
            "baseName": "part_1_text",
            "type": "string",
            "format": ""
        },
        {
            "name": "part_1_medias",
            "baseName": "part_1_medias",
            "type": "Array<ApiDropMedia>",
            "format": ""
        },
        {
            "name": "has_quote",
            "baseName": "has_quote",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "is_reply_drop",
            "baseName": "is_reply_drop",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiLightDrop.attributeTypeMap;
    }

    public constructor() {
    }
}



